var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackPerformanceProIconTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 147,
    viewBox: "0 0 195 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.28 16.2464L172.182 14.5868L176.336 11.8383L177.434 13.4979L173.28 16.2464Z",
    fill: "#142533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.069 20.3547L165.971 18.6952L170.126 15.9466L171.224 17.6062L167.069 20.3547Z",
    fill: "#142533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.253 24.2026L160.155 22.5431L164.31 19.7946L165.407 21.4541L161.253 24.2026Z",
    fill: "#142533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.436 28.0505L154.338 26.391L158.493 23.6425L159.591 25.302L155.436 28.0505Z",
    fill: "#142533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.598 31.913L148.5 30.2534L152.654 27.5049L153.752 29.1644L149.598 31.913Z",
    fill: "#142533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.781 35.7609L142.683 34.1014L146.838 31.3528L147.936 33.0124L143.781 35.7609Z",
    fill: "#142533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.964 39.6088L136.866 37.9493L141.021 35.2008L142.119 36.8603L137.964 39.6088Z",
    fill: "#142533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.148 43.4568L131.05 41.7972L135.204 39.0487L136.302 40.7082L132.148 43.4568Z",
    fill: "#142533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.331 47.3047L125.233 45.6452L129.388 42.8966L130.486 44.5562L126.331 47.3047Z",
    fill: "#142533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.514 51.1526L119.416 49.4931L123.571 46.7446L124.669 48.4041L120.514 51.1526Z",
    fill: "#142533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 55.0005L113.6 53.341L117.755 50.5925L118.852 52.252L114.698 55.0005Z",
    fill: "#142533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 55.0005L113.6 53.341L117.755 50.5925L118.852 52.252L114.698 55.0005Z",
    fill: "#142533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 55.0005L113.6 53.341L117.755 50.5925L118.852 52.252L114.698 55.0005Z",
    fill: "#142533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 55.0005L113.6 53.341L117.755 50.5925L118.852 52.252L114.698 55.0005Z",
    fill: "#142533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.881 58.8485L107.783 57.189L111.938 54.4404L113.036 56.1L108.881 58.8485Z",
    fill: "#142533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.881 58.8485L107.783 57.189L111.938 54.4404L113.036 56.1L108.881 58.8485Z",
    fill: "#142533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.881 58.8485L107.783 57.189L111.938 54.4404L113.036 56.1L108.881 58.8485Z",
    fill: "#142533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.881 58.8485L107.783 57.189L111.938 54.4404L113.036 56.1L108.881 58.8485Z",
    fill: "#142533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.064 62.6964L101.967 61.0369L106.121 58.2884L107.219 59.9479L103.064 62.6964Z",
    fill: "#142533"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.064 62.6964L101.967 61.0369L106.121 58.2884L107.219 59.9479L103.064 62.6964Z",
    fill: "#142533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.064 62.6964L101.967 61.0369L106.121 58.2884L107.219 59.9479L103.064 62.6964Z",
    fill: "#142533"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.064 62.6964L101.967 61.0369L106.121 58.2884L107.219 59.9479L103.064 62.6964Z",
    fill: "#142533"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2478 66.5443L96.1499 64.8848L100.305 62.1363L101.403 63.7958L97.2478 66.5443Z",
    fill: "#142533"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2478 66.5443L96.1499 64.8848L100.305 62.1363L101.403 63.7958L97.2478 66.5443Z",
    fill: "#142533"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2478 66.5443L96.1499 64.8848L100.305 62.1363L101.403 63.7958L97.2478 66.5443Z",
    fill: "#142533"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2478 66.5443L96.1499 64.8848L100.305 62.1363L101.403 63.7958L97.2478 66.5443Z",
    fill: "#142533"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 70.3923L90.3333 68.7327L94.488 65.9842L95.5859 67.6438L91.4312 70.3923Z",
    fill: "#142533"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M179.112 12.2341L178.014 10.5745L182.169 7.82603L183.267 9.48555L179.112 12.2341Z",
    fill: "#142533"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184.943 8.36755L183.845 6.70802L188 3.9595L189.097 5.61902L184.943 8.36755Z",
    fill: "#142533"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M190.845 4.40805L189.747 2.74852L193.902 0L195 1.65952L190.845 4.40805Z",
    fill: "#142533"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.8104,
    cy: 97.2488,
    rx: 49.8104,
    ry: 49.7512,
    fill: "#142533"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8483 102.064C28.2446 101.336 28.5168 100.345 29.4476 99.8809C30.5352 99.3387 37.0794 90.8313 36.8562 90.2498C36.7566 89.9902 36.938 89.5153 37.2587 89.1943C38.3926 88.0604 39.9409 88.7063 39.9409 90.3131C39.9409 91.2794 42.3558 96.1346 42.8364 96.1346C43.0119 96.1346 45.9023 92.7085 49.2598 88.5211L55.3642 80.9075L54.4239 80.1487L53.4835 79.3899L55.5797 79.2085C56.7327 79.1086 57.7213 79.0655 57.7767 79.1125C58.0443 79.3398 58.2756 82.8781 58.0226 82.8781C57.8628 82.8781 57.467 82.6381 57.143 82.3449C56.6078 81.8605 55.9838 82.5241 50.3327 89.5869C46.911 93.8633 44.0407 97.7326 43.9542 98.1854C43.7678 99.161 42.3302 99.646 41.5482 98.9971C41.2552 98.7539 41.0152 98.087 41.0152 97.515C41.0152 96.5698 38.628 91.2323 38.3383 91.5298C38.2706 91.5993 36.6771 93.6398 34.7971 96.0644C32.7306 98.7295 31.4582 100.679 31.5795 100.995C32.0681 102.269 29.7661 103.169 28.8483 102.064ZM62.5541 72.8066C52.148 62.3978 35.2142 62.3978 24.8064 72.8066C14.3979 83.2128 14.3979 100.147 24.8064 110.554C34.8571 120.605 50.9936 120.947 61.4614 111.586L63.5776 113.703C63.0507 115.052 63.3269 116.641 64.4161 117.73L75.5824 128.896C77.0503 130.365 79.4313 130.365 80.8984 128.896C82.3672 127.429 82.3672 125.049 80.8984 123.579L69.733 112.416C68.6429 111.325 67.0529 111.049 65.704 111.576L63.5878 109.459C72.9507 98.9921 72.6055 82.8556 62.5541 72.8066ZM27.9961 107.365C19.3475 98.7177 19.3475 84.6438 27.9961 75.9951C36.644 67.3465 50.7175 67.3465 59.366 75.9951C68.0146 84.6438 68.0146 98.7176 59.366 107.365C50.7175 116.013 36.644 116.013 27.9961 107.365Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackPerformanceProIconTail);
export default __webpack_public_path__ + "static/media/TrackPerformanceProIconTail.5708c411f9a54f1e78a5c5e16d60d4b7.svg";
export { ForwardRef as ReactComponent };